export default "__VITE_ASSET__1f84f5fa__"